import type { ComponentProps } from "react"

export default function Building(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M3.83333 13.8333V11.1667H7.83333V13.8333M3.16667 3.16667H3.17333M8.5 3.16667H8.50667M5.83333 3.16667H5.84M5.83333 5.83333H5.84M5.83333 8.5H5.84M8.5 5.83333H8.50667M8.5 8.5H8.50667M3.16667 5.83333H3.17333M3.16667 8.5H3.17333M1.83333 0.5H9.83333C10.5697 0.5 11.1667 1.09695 11.1667 1.83333V12.5C11.1667 13.2364 10.5697 13.8333 9.83333 13.8333H1.83333C1.09695 13.8333 0.5 13.2364 0.5 12.5V1.83333C0.5 1.09695 1.09695 0.5 1.83333 0.5Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
